import TreeNode from "./TreeNode";

export default function Tree({ nodes, onFileClick, searchTerm }) {
  return (
    <ul className="tree">
      {Object.entries(nodes).map(([name, node]) => (
        <TreeNode
          key={name}
          name={name}
          node={node}
          onFileClick={onFileClick}
          searchTerm={searchTerm}
        />
      ))}
    </ul>
  );
}